import { Observable, Subject } from 'rxjs';
import { Brand } from '../../models/brand';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { BaseDao } from './BaseDao';

export class BrandDao extends BaseDao {
  private currentBrand: Brand;

  private brandSource: Subject<Brand>;
  public brandChange$: Observable<Brand>;

  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.BRAND, apiHelper);
    this.brandSource = new Subject<Brand>();
    this.brandChange$ = this.brandSource.asObservable();
  }

  public getCurrentBrand(): Brand {
    return this.currentBrand;
  }

  public setCurrentBrand(id: string): void {
    window.localStorage.setItem('advocado_brand', id);

    if (id) {
      this.loadById(id).subscribe(res => {
        this.currentBrand = res as Brand;
        this.brandSource.next(this.currentBrand);
      });
    } else {
      this.currentBrand = null;
      this.brandSource.next(null);
    }
  }

  public loadByTriggerId(triggerId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/trigger/' + triggerId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

  public archiveById(triggerId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/archive/' + triggerId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'DELETE', null, null, headers);
  }

  public createBrand(brand: any): Observable<Brand> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, brand, headers, null);
  }

  public toggleUserEnabledStatus(brandId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/userEnabled/' + brandId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, null, headers, null);
  }

  public rename(id: string, name: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/rename';
    let headers = this.apiHelper.getDefaultHeader();
    let data = {
      id,
      name
    };
    return this.apiHelper.apiCall(url, 'POST', null, data, headers);
  }

  public update(data:any): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' ;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'PUT', null, data, headers);
  }

  public findByAdvertiserId(advertiserId: string): Observable<Brand[]> {
    let url = this.apiHelper.getServiceName() + this.getResource() + `/advertiser/${advertiserId}`;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers);
  }

}
